import TostActionTypes from './toast.type';

export const ToastShow = (message) => ({
  type: TostActionTypes.SET_TOAST,
  payload: message,
});
